import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./Redux/app/store";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./Redux/app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>{" "}
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
reportWebVitals();
